import { useQueries } from '@tanstack/react-query';
import { TrendsResult } from 'api/useAnalytics';
import { EQueryKeys } from 'constants/enums';
import useAxios from 'hooks/useAxios';

import { BUSINESS_ANALYTICS } from '../../utils';

interface UseTrendsQueriesProps {
  publisherId?: string;
  selectedAttributeName?: string;
  selectedAttributeValues: string[];
  apiDateRange?: {
    from?: string;
    to?: string;
  };
}

export const useTrendsQueries = ({
  publisherId,
  selectedAttributeName,
  selectedAttributeValues,
  apiDateRange,
}: UseTrendsQueriesProps) => {
  const axios = useAxios();

  return useQueries({
    queries: selectedAttributeValues.map(value => {
      return {
        queryKey: [`${EQueryKeys.TRENDS}_${apiDateRange?.from}_${apiDateRange?.to}_${JSON.stringify({ [selectedAttributeName!]: [value] })}`],
        queryFn: async (): Promise<TrendsResult[]> => {
            if (!apiDateRange?.from || !apiDateRange?.to) return [];
            const data = await axios.get('/dashboard/analytics/trends', {
                startDate: apiDateRange.from,
                endDate: apiDateRange.to,
                metrics: BUSINESS_ANALYTICS,
                attributeFilters: { [selectedAttributeName!]: [value] }
            }, publisherId ? { 'x-publishers': publisherId } : undefined);
            return data.trends;
        },
        enabled: !!publisherId && !!selectedAttributeName && selectedAttributeValues.length > 0,
      }
    })
  });
}; 